function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const CommentIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 12c0 5.5-6.3 10-14 10-.8 0-1.5 0-2.3-.1-2 1.8-4.5 3.1-7.2 3.8-.5.1-1.1.2-1.7.3-.3 0-.7-.2-.8-.6-.1-.4.2-.6.4-.9 1-1.1 2.1-2 2.8-4.7C2.1 18 0 15.2 0 12 0 6.5 6.3 2 14 2s14 4.5 14 10z"
  }));
};
export default CommentIcon;